const hasLinkOrButtonChild = element => {
  return element.querySelectorAll('a, button').length !== 0;
};

const isInputField = element => {
  return element.tagName === 'INPUT';
};

const hasParentLinkOrButton = element => {
  if (!element || element.tagName === 'TD' || element.tagName === 'TR') {
    return false;
  }
  if (
    element.className
      .toString()
      .split(' ')
      .indexOf('collapse-button') !== -1
  ) {
    return false;
  }
  if (element.tagName === 'BUTTON' || element.tagName === 'A') {
    return true;
  }
  return hasParentLinkOrButton(element.parentElement);
};

export default element => {
  if (!element || element.tagName === 'TD' || element.tagName === 'TR') {
    return false;
  }
  return isInputField(element) || hasLinkOrButtonChild(element) || hasParentLinkOrButton(element);
};
